import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=3733bc08&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3733bc08",
  null
  
)

export default component.exports